"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFlowNodeType = mapFlowNodeType;
const sonar_ts_constants_1 = require("@sonar-software/sonar-ts-constants");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
const flowNodeTypeMap = {
    [sonar_ts_types_1.SfNodeType.Decisions]: sonar_ts_constants_1.FLOW_NODE_TYPES.DECISION,
    [sonar_ts_types_1.SfNodeType.RecordCreates]: sonar_ts_constants_1.FLOW_NODE_TYPES.RECORD_CREATE,
    [sonar_ts_types_1.SfNodeType.RecordLookups]: sonar_ts_constants_1.FLOW_NODE_TYPES.RECORD_LOOKUP,
    [sonar_ts_types_1.SfNodeType.RecordUpdates]: sonar_ts_constants_1.FLOW_NODE_TYPES.RECORD_UPDATE
};
function mapFlowNodeType(nodeType) {
    var _a;
    if (!nodeType) {
        return nodeType;
    }
    return (_a = flowNodeTypeMap[nodeType]) !== null && _a !== void 0 ? _a : nodeType;
}
//# sourceMappingURL=lib.js.map